/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".env-indicator[_ngcontent-%COMP%]{background:gray;border-radius:2px;-webkit-border-radius:2px;top:12px;color:#fff;left:12px;padding:12px;position:fixed;text-transform:uppercase}.env-indicator.local[_ngcontent-%COMP%]{background:#e03636;color:#fff}.env-indicator.dev[_ngcontent-%COMP%]{background:#31aaf3;color:#fff}.env-indicator.cert[_ngcontent-%COMP%]{background:#37b779;color:#fff}"];
export { styles as styles };
